<template>
  <div class="timer" v-if="diff>=0">
    <template v-if="days">
      <span class="count">{{ $format2Digits(days) }}</span>
      <span class="count-title">j</span>
    </template>
    <template v-if="hours">
      <span class="count">{{ $format2Digits(hours) }}</span>
      <span class="count-title">h</span>
    </template>
    <template v-if="forceMinutes ||minutes">
      <span class="count">{{ $format2Digits(minutes) }}</span>
      <span class="count-title">min</span>
    </template>
    <template v-if="forceSeconds || seconds">
      <span class="count">{{ $format2Digits(seconds) }}</span>
      <span class="count-title">sec</span>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import {mapGetters} from "vuex";

export default {
  name: "Timer",
  props: {
    value: {},
    forceSeconds: {type: Boolean, default: false},
    forceMinutes: {type: Boolean, default: false},
  },
  data() {
    return {
      date: moment(this.value),
      interval: null
    }
  },
  computed: {
    ...mapGetters(['now']),
    diff() {
      const tmp = this.date.diff(this.now, 's')
      if (tmp === 0) this.$emit('end')
      return tmp
    },
    days() {
      return this.date.diff(this.now, 'd')
    },
    hours() {
      return this.date.diff(this.now, 'h') % 24
    },
    minutes() {
      return this.date.diff(this.now, 'minute') % 60
    },
    seconds() {
      return this.date.diff(this.now, 's') % 60
    }
  }
}
</script>

<style lang="scss" scoped>
.timer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: $green;
  font-weight: bold;

  .count {
    font-size: 30px;
    margin-right: 2px;
  }

  .count-title {
    font-size: 18px;
    margin-right: 10px;
  }
}
</style>
